// Module
var code = "<template>\n  <button\n    type=\"button\"\n    disabled.bind=\"disabled\"\n    class=\"button button--smallest button--noborder button--nominwidth button--primary\"\n    class.bind=\"classes + ' ' + styleClasses\"\n    click.delegate=\"onClick()\"\n  >\n    <slot></slot>\n  </button>\n</template>\n";
// Exports
export default code;